import React from 'react';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { AddInternalProcurementType } from 'models/procurement.model';
import useDashboardContext from 'contexts/dashboard.context';

const ExcessReturnsPreview = ({
  formData,
  handleEdit
}: {
  formData: AddInternalProcurementType[];
  handleEdit: () => void;
}) => {
  const { formStoreItems } = useDashboardContext();
  const getIngredient = (id: string) => formStoreItems?.find((ingredient) => ingredient.id === id);

  return (
    <div>
      {formData.map((data, index) => (
        <div
          className='flex justify-between border-b border-b-[#EAEBEB] py-6 gap-6 items-center'
          key={index}>
          <div>
            <p className='font-medium text-[#2E3031] capitalize'>
              {getIngredient(data.ingredient_id)?.name}
            </p>
            <div className='flex gap-2 flex-wrap'>
              <p className='text-sm font-medium text-[#2E3031]'>
                {data.quantity} {data.unit_type}
              </p>
            </div>
          </div>
          <EditIcon onClick={handleEdit} className='cursor-pointer' />
        </div>
      ))}
    </div>
  );
};

export default ExcessReturnsPreview;
